// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../style.css\"","easilGrayXLight":"#D1D4D6","radioboxRoundedLabel":"style_radioboxRoundedLabel__3cNHV"};